import i18n from "features/shared/i18n";
import { AppUser } from "features/user/types";
import { translateSingleValue, translateAccessoryValues } from "./playerTabUtils";

export function AppearanceSection({ selectedUser }: { selectedUser: AppUser }) {
  return (
    <div className="flex-col-el">
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[140px] shrink-0">
          {i18n.t("MSG_ACCESSORY_TITLE_BY_PARENT")}
        </div>
        <div className="text-[21px] text-textcolor-black flex-1 truncate">
          {translateAccessoryValues(selectedUser.accessory)}
        </div>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[140px] shrink-0">
          {i18n.t("MSG_PROFILE_AI_HAIRSTYLE_BY_PARENT")}
        </div>
        <div className="text-[21px] text-textcolor-black flex-1 truncate">
          {translateSingleValue(selectedUser.hairstyle, "hairstyle")}
        </div>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[140px] shrink-0">
          {i18n.t("MSG_PROFILE_AI_BODY_TYPE_BY_PARENT")}
        </div>
        <div className="text-[21px] text-textcolor-black flex-1 truncate">
          {translateSingleValue(selectedUser.body_type, "body_type")}
        </div>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 overflow-hidden">
        <div className="text-[18px] text-gray2-100 w-[140px] shrink-0">
          {i18n.t("MSG_PROFILE_AI_FACE_SHAPE_BY_PARENT")}
        </div>
        <div className="text-[21px] text-textcolor-black flex-1 truncate">
          {translateSingleValue(selectedUser.face_shape, "face_shape")}
        </div>
      </div>
    </div>
  );
}
